import _ from "lodash";

const service = ((w) => {
  const STORAGE_TYPES = { LOCAL: "local", SESSION: "session", MEMORY: "memory" };

  let allowedTypes = [STORAGE_TYPES.LOCAL, STORAGE_TYPES.SESSION, STORAGE_TYPES.MEMORY];
  let defaultType = STORAGE_TYPES.MEMORY;
  let memoryStorage = {};

  // Set default type
  const setDefaultType = (type) => {
    defaultType = allowedTypes.indexOf(type) !== -1 ? type : defaultType;
  };

  // Get default type
  const getDefaultType = () => defaultType;

  // Set value
  const set = (key, value, config) => {
    // 'key', 'value' are required
    if (!key || !value || typeof key !== "string" || !key.trim().length) return;

    // 'config' must be an object
    if (config && typeof config !== "object") return;

    // Create 'config', if not available
    if (!config) {
      config = {};
    }

    // Defaultify 'config.type'
    config.type =
      config.type && typeof config.type === "string" && allowedTypes.indexOf(config.type.trim().toLowerCase()) !== -1 ? config.type : defaultType;

    // Push value to storage
    switch (config.type.toLowerCase()) {
      case STORAGE_TYPES.LOCAL:
        w.localStorage.setItem(key, value);
        break;
      case STORAGE_TYPES.SESSION:
        w.sessionStorage.setItem(key, value);
        break;
      case STORAGE_TYPES.MEMORY:
        memoryStorage[key] = value && typeof value === "object" ? (_.isArray(value) ? value.slice() : { ...value }) : value;
        break;
    }

    return true;
  };

  // Get value
  const get = (key, config) => {
    // 'key' is required
    if (!key || typeof key !== "string" || !key.trim().length) return;

    // 'config' must be an object
    if (config && typeof config !== "object") return;

    // Create 'config', if not available
    if (!config) {
      config = {};
    }

    // Defaultify 'config.type'
    config.type =
      config.type && typeof config.type === "string" && allowedTypes.indexOf(config.type.trim().toLowerCase()) !== -1 ? config.type : defaultType;

    let value = undefined;

    switch (config.type.toLowerCase()) {
      case STORAGE_TYPES.LOCAL:
        value = w.localStorage.getItem(key);
        break;
      case STORAGE_TYPES.SESSION:
        value = w.sessionStorage.getItem(key);
        break;
      case STORAGE_TYPES.MEMORY:
        value = typeof memoryStorage[key] !== "undefined" ? memoryStorage[key] : null;
        break;
    }

    return value && typeof value === "object" ? (_.isArray(value) ? value.slice() : { ...value }) : value;
  };

  // Unset specific data from a specific storage type
  const remove = (key, type) => {
    // 'key' is required
    if (!key || typeof key !== "string" || !key.trim().length) return;

    // Defaultify 'type'
    type = type && typeof type === "string" && allowedTypes.indexOf(type.trim().toLowerCase()) !== -1 ? type : defaultType;

    switch (type.toLowerCase()) {
      case STORAGE_TYPES.LOCAL:
        w.localStorage.removeItem(key);
        break;
      case STORAGE_TYPES.SESSION:
        w.sessionStorage.removeItem(key);
        break;
      case STORAGE_TYPES.MEMORY:
        delete memoryStorage[key];
        break;
    }

    return true;
  };

  // Erase a specific storage type
  const erase = (type) => {
    // 'type' is required
    type = type && typeof type === "string" && allowedTypes.indexOf(type.trim().toLowerCase()) !== -1 ? type : defaultType;

    switch (type.toLowerCase()) {
      case STORAGE_TYPES.LOCAL:
        w.localStorage.clear();
        break;
      case STORAGE_TYPES.SESSION:
        w.sessionStorage.clear();
        break;
      case STORAGE_TYPES.MEMORY:
        memoryStorage = {};
        break;
    }

    return true;
  };

  // Wipe all storage types
  const wipe = () => {
    w.localStorage.clear();
    w.sessionStorage.clear();
    memoryStorage = {};
  };

  return { STORAGE_TYPES, getDefaultType, setDefaultType, set, get, remove, erase, wipe };
})(window);

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/web-storage.js